import React, { Component } from 'react';
import { GoogleMap, LoadScript, Marker, MarkerClusterer } from '@react-google-maps/api';
import {
  Segment, Message
} from "semantic-ui-react";
import request from "../../utils/request";
import { AppContext } from "../../utils/context";

const mapContainerStyle  = {
  width: '1920px',
  height: '762px'
};

const options = {
  imagePath:'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m', // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
  mapTypeControl: false,
  averageCenter: true,
};

class GoogleMapMarkerCluster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      locations: [],
      message: null
    };
  }

  componentDidMount = () => {
    this.fetchData();
  };

  fetchData = () => {
    let payload = {
      'type' : this.props.type === 'campaign' ? 'campaign' : 'event',
      'id': this.props.type === 'campaign' ? this.props.campaignId : this.props.eventId
    }
    request
      .post(this, `api:/payments-coordinator`, payload)
      .then(resp => {
        if (resp.status == 'success') {
          if (resp.data.length == 0) {
            this.setState({
              isLoading: false,
              locations: resp.data,
              message: "No Payment in Last 10 mins"
            });
          } else {
            this.setState({
              isLoading: false,
              locations: resp.data,
            });
          }
        }
        else if (resp.status == 'error') {
          this.setState({
            isLoading: false,
            locations: [],
            message: resp.message
          });
        }
      }).catch(err => {
        this.setState({
          isLoading: false,
          locations: [],
          message: err.message
        });      
      });
  };

  render() {
    const {
        locations,
        isLoading,
        message
      } = this.state;
      
      let center = locations[0];
    return (
      <Segment basic isloading={+isLoading}>
        { message !== null ? <Message
          error
          content={message}
        /> : null
        }
        {message == null ? <div className="googlemap">
        <LoadScript googleMapsApiKey={this.context.config.google_api_key}>
          <GoogleMap 
              id="google-map" 
              mapContainerStyle={mapContainerStyle} 
              zoom={5} 
              center={center} >
          <MarkerClusterer 
            options={options}
          >
            {(clusterer) =>
              locations.map((location, key) => (
                <Marker key={location.lat + location.lng + key} position={location} clusterer={clusterer} />
              ))
            }
          </MarkerClusterer>
          </GoogleMap>
        </LoadScript>
      </div> : null}
    </Segment>
    )
  }
}

export default GoogleMapMarkerCluster;
GoogleMapMarkerCluster.contextType = AppContext;